<template>
	<div class="absolute bottom-3 right-0 z-10">
		<CarbarBadge
			v-if="discountSet"
			:background-color="badgeColor"
			rounded="rounded-l"
		>
			{{ badgeText }}
		</CarbarBadge>
	</div>
</template>

<script setup>
import CarbarBadge from '@/components/badges/CarbarBadge.vue'

const props = defineProps({
	discountSet: {
		type: Object,
		required: true,
	},
})

const { badgeText, badgeColor } = getCampaignBadgeInfo(props.discountSet)
</script>
